import { reactive } from 'vue'

export default reactive<any>({
  organizationsApiKeys: {
    count: 0,
    items: [],
  },
  apiKey: null,
  organizations: {
    count: 0,
    items: [],
  },
  organization: null,
  current: null,
})
